import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ORDER_ID_LOADING = 'GET_ORDER_ID_LOADING';
export const GET_ORDER_ID_SUCCESS = 'GET_ORDER_ID_SUCCESS';
export const GET_ORDER_ID_REJECT = 'GET_ORDER_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getOrderIdLoading = () => ({ type: GET_ORDER_ID_LOADING });
export const getOrderIdSuccess = (payload) => ({ type: GET_ORDER_ID_SUCCESS, payload });
export const getOrderIdReject = (payload) => ({ type: GET_ORDER_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getOrderIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Order/${id}`, options);
};